import { render, staticRenderFns } from "./SystemComponentForm.vue?vue&type=template&id=5bdacf16&"
import script from "./SystemComponentForm.vue?vue&type=script&lang=js&"
export * from "./SystemComponentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports